"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnstyledInputIcon;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _information = _interopRequireDefault(require("@sfly/uig-svg-icon/notifications/information"));

var _error_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/notifications/error_selected"));

var _select_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/action/select_selected"));

require("./unstyledInputIcon.css");

function UnstyledInputIconContainer(props) {
  var hintMessage = props.hintMessage;
  var style = hintMessage ? {
    content: hintMessage
  } : null;
  return _react.default.createElement("span", {
    className: "unstyled_input_icon_container",
    style: style
  }, props.children);
}

UnstyledInputIconContainer.propTypes = {
  hintMessage: _propTypes.default.string,
  children: _propTypes.default.node
};

function UnstyledInputIcon(props) {
  var _props$hint = props.hint,
      hintType = _props$hint.hintType,
      hintMessage = _props$hint.hintMessage;
  var Icons = {
    info: _information.default,
    error: _error_selected.default,
    success: _select_selected.default
  };
  var Icon = Icons[hintType];
  return _react.default.createElement(InputIconContainer, {
    hintMessage: hintMessage
  }, _react.default.createElement(Icon, null));
}

UnstyledInputIcon.propTypes = {
  hint: _propTypes.default.shape({
    hintType: _propTypes.default.oneOf(['success', 'error', 'info']).isRequired,
    hintMessage: _propTypes.default.string
  })
};